import { Measure } from './measure'

import { OpDevice } from '../core/op-device'
import { OpLocation } from '../core/op-location'
import { OpMeter } from '../core/op-meter'

export class MeasureCollection {
    public idDataType: number
    public idLocation: number
    public idMeter: number
    public serialNbr: number
    public indexNbr: number
    public measures: Measure[]

    public device: OpDevice
    public location: OpLocation
    public meter: OpMeter

    constructor(opObj: any = null) {
        if (opObj) {
            this.idDataType = opObj.IdDataType
            this.idLocation = opObj.IdLocation
            this.idMeter = opObj.IdMeter
            this.serialNbr = opObj.SerialNbr
            this.indexNbr = opObj.IndexNbr
            this.measures = opObj.Measures ? opObj.Measures.map(m => new Measure(m)) : []

            this.device = opObj.Device != null ? new OpDevice(opObj.Device) : null
            this.location = opObj.Location != null ? new OpLocation(opObj.Location) : null
            this.meter = opObj.Meter != null ? new OpMeter(opObj.Meter) : null
        }
    }
}